module.exports = __webpack_public_path__ + "static/media/DaikinTIC-2d.ec247442.png";